import React from "react";
import Chat from "../components/Chat";

// Import the JSON data
import news from "../models/todayNews.json";
import assets from "../models/assets.json";

function Assistant() {
  return (
    <div>
      {/* Pass the imported JSON data to the Assistant component */}
      <Chat news={news} assets={assets} />
    </div>
  );
}

export default Assistant;